module.exports = __webpack_public_path__ + "img/location-singapore-hover.b564bf60.jpg";